<template>
    <div class="footer-wrapper">
        <footer id="footer">
            <div class="footer-container">
                <div class="footer-col footer-brand">
                    <img src="@/assets/img/bebio777_Logo.png" alt="Betbio 777" class="footer-logo" />
                    <p class="footer-desc">worldcupsports is the #1 Gaming Platform and offers the best experience & rewards to our users.</p>
                    <p class="footer-slogan">Innovative Gaming Experience</p>
                </div>
                <div class="footer-links-group">
                <div class="footer-col footer-links-col">
                    <h3 class="footer-heading">About Us</h3>
                    <div class="footer-links">
                        <button type="button" v-on:click="modalsSetShow('Terms')" aria-label="Terms of Service">TOS</button>
                        <button type="button" v-on:click="modalsSetShow('Faq')" aria-label="Frequently asked questions">FAQ</button>
                        <button type="button" v-on:click="modalsSetShow('Privacy')" aria-label="Privacy policy">Privacy</button>
                    </div>
                </div>
                <div class="footer-col footer-links-col">
                    <h3 class="footer-heading">Additional</h3>
                    <div class="footer-links">
                        <router-link to="/affiliates">Affiliates</router-link>
                        <router-link to="/leaderboard">Leaderboard</router-link>
                        <button type="button" v-on:click="modalsSetShow('Fair')" aria-label="Provably fair verification">Provably Fair</button>
                        <button v-if="authenticated" type="button" @click="toggleSupport" class="footer-support-link" aria-label="Open live support">
                            <span>Live Support</span>
                            <span v-if="supportUnreadCount > 0" class="support-badge-inline">{{ supportUnreadCount > 9 ? '9+' : supportUnreadCount }}</span>
                        </button>
                    </div>
                </div>
                </div>
                <div class="footer-col footer-social-col">
                    <h3 class="footer-heading">Follow Us</h3>
                    <div class="footer-social-icons">
                        <a :href="socialLinks.twitter" target="_blank" rel="noopener noreferrer" class="social-icon-link" aria-label="Follow us on X (Twitter)">
                            <div class="social-icon-container">
                                <IconTwitter />
                            </div>
                        </a>
                        <a :href="socialLinks.discord" target="_blank" rel="noopener noreferrer" class="social-icon-link" aria-label="Join our Discord">
                            <div class="social-icon-container">
                                <IconDiscord />
                            </div>
                        </a>
                        <a :href="socialLinks.telegram" target="_blank" rel="noopener noreferrer" class="social-icon-link" aria-label="Join us on Telegram">
                            <div class="social-icon-container">
                                <IconTelegram />
                            </div>
                        </a>
                    </div>
                </div>
            <div class="footer-copyright">
                <span>@2026 All rights reserved</span>
            </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import IconTwitter from '@/components/icons/IconTwitter';
    import IconDiscord from '@/components/icons/IconDiscord';
    import IconTelegram from '@/components/icons/IconTelegram';

    export default {
        name: 'Footer',
        components: {
            IconTwitter,
            IconDiscord,
            IconTelegram
        },
        data() {
            return {
                socialLinks: {
                    twitter: 'https://x.com/worldcupsports', // Update with your X/Twitter account
                    discord: 'https://discord.gg/worldcupsports', // Update with your Discord server
                    telegram: 'https://t.me/worldcupsports' // Update with your Telegram channel
                }
            };
        },
        computed: {
            ...mapGetters([
                'authenticated',
                'supportUnreadCount',
                'supportWidgetOpen'
            ])
        },
        methods: {
            ...mapActions([
                'modalsSetShow',
                'supportSetWidgetOpen',
                'supportSetView'
            ]),
            toggleSupport() {
                const newState = !this.supportWidgetOpen;
                this.supportSetWidgetOpen(newState);
                
                if(newState) {
                    this.supportSetView('list');
                }
            }
        }
    }
</script>

<style scoped>
.footer-wrapper {
    width: 100%;
    margin-top: 42px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: env(safe-area-inset-bottom, 0);
}

#footer {
    width: 100%;
  /*  max-width: 1250px; 
    padding: 0 24px 0 24px;
    margin: 0 21px 21px 21px; */
    display: flex;
    flex-direction: column;
    align-items: center;
}

.footer-container {
    position: relative;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 48px 40px 36px 40px;
    display: grid;
    grid-template-columns: minmax(180px, 260px) auto auto;
    column-gap: 64px;
    row-gap: 40px;
    align-items: center;
    justify-content: center;
}

/* Deep gradient overlay at top - transitions from page background */
.footer-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 20%;
    pointer-events: none;
    z-index: 0;
}

.footer-container > * {
    position: relative;
    z-index: 1;
}

.footer-brand {
    max-width: 280px;
}

.footer-links-group {
    display: flex;
    flex-wrap: wrap;
    gap: 32px 64px;
    align-items: start;
}

.footer-logo {
    width: 140px;
    height: auto;
    object-fit: contain;
    display: block;
    margin-bottom: 24px;
}

.footer-desc {
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.6;
    margin: 0 0 14px 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.footer-slogan {
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.footer-heading {
    font-size: 13px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.98);
    text-transform: none;
    letter-spacing: 0.3px;
    margin: 0 0 18px 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.footer-links {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.footer-links a,
.footer-links button {
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.92);
    text-decoration: none;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px 0;
    text-align: left;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    transition: color 0.2s ease, opacity 0.2s ease;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
}

.footer-links a:hover,
.footer-links button:hover {
    color: #ffffff;
    opacity: 1;
}

.footer-links a:focus-visible,
.footer-links button:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.5);
    outline-offset: 2px;
}

.footer-links a:active,
.footer-links button:active {
    opacity: 0.9;
}

.footer-links a svg,
.footer-links button svg {
    flex-shrink: 0;
}

.footer-support-link {
    position: relative;
}

.footer-support-link svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

.footer-support-link .support-badge-inline {
    margin-left: 6px;
    padding: 2px 6px;
    background: #ff4444;
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    border-radius: 10px;
    min-width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.footer-copyright {
    width: 100%;
    grid-column: 1 / -1;
    text-align: center;
    padding: 24px 0 20px 0;
    margin-top: 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-copyright span {
    font-size: 12px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.75);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.footer-social-col {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.footer-social-icons {
    display: flex;
    gap: 12px;
    align-items: center;
}

.social-icon-link {
    display: inline-block;
    text-decoration: none;
    transition: transform 0.2s ease, opacity 0.2s ease;
    border-radius: 10px;
}

.social-icon-link:hover {
    transform: translateY(-2px);
    opacity: 0.95;
}

.social-icon-link:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.5);
    outline-offset: 2px;
}

.social-icon-container {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.social-icon-link:hover .social-icon-container {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    transform: scale(1.05);
}

.social-icon-container svg {
    width: 16px;
    height: 16px;
    fill: #ffffff;
    color: #ffffff;
    transition: fill 0.3s ease;
}

@media only screen and (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr 1fr;
        gap: 40px;
        padding: 40px 24px 36px 24px;
    }

    .footer-brand {
        max-width: 100%;
        grid-column: 1 / -1;
        text-align: center;
    }

    .footer-logo {
        margin-left: auto;
        margin-right: auto;
    }

    .footer-desc,
    .footer-slogan {
        text-align: center;
    }

    .footer-slogan {
        font-size: 15px;
    }

    .footer-links-group {
        justify-content: center;
    }

    .footer-social-col {
        align-items: center;
    }

    .footer-social-icons {
        justify-content: center;
    }
}

@media only screen and (max-width: 768px) {
    .footer-wrapper {
        margin-top: 24px;
    }

    .footer-container {
        grid-template-columns: 1fr;
        gap: 20px;
        padding: 24px 16px 24px 16px;
        text-align: center;
    }

    .footer-brand {
        grid-column: 1;
        max-width: 100%;
    }

    .footer-logo {
        margin-left: auto;
        margin-right: auto;
        width: 112px;
        margin-bottom: 10px;
    }

    .footer-desc {
        font-size: 13px;
        line-height: 1.5;
        margin-bottom: 6px;
        padding: 0 6px;
    }

    .footer-slogan {
        font-size: 14px;
        font-weight: 700;
    }

    .footer-links-group {
        width: 100%;
        flex-direction: column;
        gap: 10px;
    }

    .footer-links-col {
        width: 100%;
        text-align: left;
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.02);
        padding: 12px;
    }

    .footer-heading {
        margin-bottom: 8px;
        font-size: 12px;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.88);
    }

    .footer-links {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .footer-links a,
    .footer-links button {
        justify-content: flex-start;
        min-height: 44px;
        width: 100%;
        padding: 10px 12px;
        font-size: 14px;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
        border-radius: 8px;
        color: rgba(255, 255, 255, 0.96);
        background: rgba(255, 255, 255, 0.03);
    }

    .footer-links a:active,
    .footer-links button:active {
        background: rgba(255, 255, 255, 0.1);
    }

    .footer-social-col {
        align-items: center;
        border-top: 1px solid rgba(255, 255, 255, 0.08);
        padding-top: 14px;
    }

    .footer-social-icons {
        justify-content: center;
        gap: 14px;
    }

    .social-icon-container {
        width: 44px;
        height: 44px;
        min-width: 44px;
        min-height: 44px;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
    }

    .footer-copyright {
        padding: 16px 8px 18px;
        padding-bottom: calc(18px + env(safe-area-inset-bottom, 0));
        margin-top: 2px;
    }

    .footer-copyright span {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.78);
    }
}

@media only screen and (max-width: 480px) {
    .footer-wrapper {
        margin-top: 16px;
    }

    .footer-container {
        padding: 20px 12px 20px 12px;
        gap: 16px;
    }

    .footer-logo {
        width: 96px;
        margin-bottom: 8px;
    }

    .footer-desc {
        font-size: 12px;
        padding: 0 4px;
    }

    .footer-slogan {
        font-size: 13px;
    }

    .footer-links-group {
        gap: 8px;
    }

    .footer-heading {
        margin-bottom: 8px;
        font-size: 11px;
    }

    .footer-links-col {
        padding: 10px;
        border-radius: 10px;
    }

    .footer-links a,
    .footer-links button {
        min-height: 44px;
        padding: 10px;
        font-size: 13px;
    }

    .social-icon-container {
        width: 44px;
        height: 44px;
        min-width: 44px;
        min-height: 44px;
    }

    .footer-copyright {
        padding: 14px 6px 16px;
        padding-bottom: calc(18px + env(safe-area-inset-bottom, 0));
    }

    .footer-copyright span {
        font-size: 11px;
    }
}
</style>
